import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container, Row, Col
} from 'react-bootstrap';
import './IconButton.scss';
import TempIcon from '../../components/Login/ChooseModality/tempIcon.png';
/**
 * Icon Button with optional description text and link
 * @class IconButton
 * @extends {Component}
 */
class IconButton extends Component {
  static propTypes = {
    /** Title show in the top row of the IconButton */
    title: PropTypes.string,
    /** CSS class names for styling the title */
    titleClass: PropTypes.string,
    /** Text displayed in the bottom row of the IconButton */
    description: PropTypes.object,
    /** Small image shown on the left side of the component */
    icon: PropTypes.string,
    /** CSS class names for styling the icon */
    iconClass: PropTypes.string,
    /** Function that gets executed when the component is clicked */
    onClickFunction: PropTypes.func,
  };

  static defaultProps = {
    title: 'Temporary Code',
    titleClass: '',
    icon: TempIcon,
    iconClass: '',
    description: <span>Call your help desk for a one time code</span>,
    onClickFunction: null,
  };

  render() {
    return (
      <div
        className={this.props.onClickFunction !== null ? 'clickable' : 'unclickable'}
        onClick={this.props.onClickFunction}
      >
        <Container>
          <Row>
            <Col xs={3} >
              <img className={this.props.iconClass} src={this.props.icon} width='36px' alt=''/>
            </Col>
            <Col xs={7} className='descriptionCol'>
              <Row className={this.props.onClickFunction !== null ? this.props.titleClass : 'modality-title-black'}>{this.props.title}</Row>
              <Row>{this.props.description}</Row>
            </Col>
          </Row>
        </Container>
        <hr style={{ marginTop: '0.5em', }}></hr>
      </div>
    );
  }
}

export default IconButton;
